import { render, staticRenderFns } from "./TicketPhotos.vue?vue&type=template&id=1e4b7f17"
import script from "./TicketPhotos.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketPhotos.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports